import * as yup from 'yup'

export const editProfile = yup.object().shape({
  name: yup.string().optional(),
  email: yup.string().email('Invalid email address').optional(),
  phone: yup.string().optional(),
  address: yup.string().optional(),
  dateOfBirth: yup
    .string()
    .matches(/^\d{4}-\d{2}-\d{2}$/, 'Date of birth must be in YYYY-MM-DD format')
    .optional(),
  gender: yup
    .string()
    .oneOf(['MALE', 'FEMALE', 'OTHERS'], 'Gender must be one of MALE, FEMALE, or OTHERS')
    .optional(),
  nationality: yup.string().optional(),
})
